function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.videoBanner = document.querySelector('.baner-video-hair-page')
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    if (this.videoBanner != null) {
      this.videoBanner.style.zIndex = "-1";
    }
  }

  closeMenuDrawer(event, elementToFocus) {
    this.videoBanner = document.querySelector('.baner-video-hair-page')
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');

    window.removeEventListener('resize', this.onResize);
    setTimeout(() => {
      if (this.videoBanner != null) {
        this.videoBanner.style.zIndex = "0";
      }
    });

  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

function openHeaderSearchFromDrawer(event) {
  event.preventDefault();

  const trigger = event.currentTarget;
  const headerDrawer = trigger.closest('header-drawer');
  const searchModal = document.getElementById('HeaderSearchModal');

  const openSearch = () => {
    if (!searchModal || searchModal.isOpen()) return;
    searchModal.open({ target: searchModal.querySelector('summary') });
  };

  if (headerDrawer?.mainDetailsToggle?.hasAttribute('open')) {
    const menuSummary = headerDrawer.mainDetailsToggle.querySelector('summary');
    headerDrawer.closeMenuDrawer(event, menuSummary);
    // closeMenuDrawer only clears aria-expanded on keyboard close; the menu
    // ::before overlay stays until this is reset.
    menuSummary?.setAttribute('aria-expanded', 'false');
    setTimeout(openSearch, 50);
    return;
  }

  openSearch();
}

document.querySelectorAll('[data-open-header-search]').forEach((trigger) => {
  trigger.addEventListener('click', openHeaderSearchFromDrawer);
});

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, { once: true });
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    try {
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantStatuses();
    } catch (e) {
      /* No checked option yet — leave availability until the first change. */
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    /* A gallery that is not Dawn's viewer — the hybrid PDP filters its own
       slides and never defines setActiveMedia — must not abort the rest of
       the variant change. That call used to throw, so the URL, the hidden
       variant id and the section re-render never ran, and add to bag posted
       whatever variant had been selected before. */
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => {
      if (typeof mediaGallery.setActiveMedia !== 'function') return;
      try {
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
      } catch (e) {
        /* The featured slide is not in this gallery. Continue so the
           variant id and the section re-render still update. */
      }
    });

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (newMediaModal) modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}_2`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const variantData = this.getVariantData();
    const checked = this.querySelector(':checked');
    if (!checked || !variantData) return;
    const selectedOptionOneVariants = variantData.filter(
      (variant) => checked.value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector('slideshow-component') &&
            !this.querySelector('.complementary-swiper') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          if (this.classList.contains('complementary-products')) {
            initComplementarySwipers(this);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function initComplementarySwipers(root) {
  if (!root || typeof Swiper === 'undefined') return;
  var containers = root.querySelectorAll('.complementary-swiper');
  containers.forEach(function (container) {
    if (container.dataset.swiperInitialized === 'true') return;

    var prevEl = container.querySelector('.slider-button--prev');
    var nextEl = container.querySelector('.slider-button--next');
    var currentEl = container.querySelector('[data-complementary-current]');
    var totalEl = container.querySelector('[data-complementary-total]');
    var total = parseInt(container.dataset.complementaryTotal || '0', 10);

    // Wrapper holding the prev/next arrows and the "1 / N" counter.
    var sliderButtons = container.querySelector('.slider-buttons');

    // Hide arrows + counter when every product already fits in the current view
    // (Swiper sets isLocked via watchOverflow). This is responsive: e.g. 3 cards
    // with 3 per page hide the controls on desktop but still show them on mobile
    // where only 2 fit at a time.
    function updateNavVisibility(sw) {
      if (!sliderButtons) return;
      sliderButtons.style.display = sw.isLocked ? 'none' : '';
    }

    // "Number of products per page" block setting (when provided) drives how many
    // cards are visible at once. The desktop view shows exactly this many; smaller
    // screens are capped down proportionally. When the attribute is absent the
    // swiper keeps its original hardcoded responsive defaults.
    var hasPerPage = container.dataset.productsPerPage != null && container.dataset.productsPerPage !== '';
    var perPage = parseInt(container.dataset.productsPerPage || '0', 10);
    if (hasPerPage && (!perPage || perPage < 1)) perPage = 1;

    function cap(n) {
      if (!hasPerPage) return n;
      return Math.max(1, Math.min(perPage, n));
    }

    var swiper = new Swiper(container, {
      slidesPerView: cap(2),
      spaceBetween: 10,
      loop: hasPerPage ? total > perPage : total > 1,
      centeredSlides: false,
      watchOverflow: true,
      preventClicks: false,
      preventClicksPropagation: false,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        640: { slidesPerView: cap(2), spaceBetween: 10 },
        750: { slidesPerView: cap(3), spaceBetween: 10 },
        1100: { slidesPerView: cap(4), spaceBetween: 10 },
        1500: { slidesPerView: hasPerPage ? perPage : 5, spaceBetween: 10 },
      },
      on: {
        init: function () {
          var maxSlides = this.slides.length - this.loopedSlides * 2;
          if (currentEl) currentEl.textContent = this.realIndex + 1;
          if (totalEl) totalEl.textContent = maxSlides > 0 ? maxSlides : this.slides.length;
          updateNavVisibility(this);
        },
        slideChange: function () {
          if (currentEl) currentEl.textContent = this.realIndex + 1;
        },
        resize: function () {
          updateNavVisibility(this);
        },
        breakpoint: function () {
          updateNavVisibility(this);
        },
        lock: function () {
          updateNavVisibility(this);
        },
        unlock: function () {
          updateNavVisibility(this);
        },
      },
    });

    container.dataset.swiperInitialized = 'true';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initComplementarySwipers(document);
  });
} else {
  initComplementarySwipers(document);
}

document.addEventListener('change', function (event) {
  var checkbox = event.target;
  if (!checkbox || !checkbox.classList || !checkbox.classList.contains('complementary-card__checkbox')) return;
  var card = checkbox.closest('.complementary-card');
  if (!card) return;
  card.classList.toggle('is-selected', checkbox.checked);
});

document.addEventListener('click', function (event) {
  var label = event.target.closest('.complementary-card__label');
  if (!label) return;
  var card = label.closest('.complementary-card');
  if (!card) return;
  var checkbox = card.querySelector('.complementary-card__checkbox');
  if (!checkbox || checkbox.disabled) return;
  event.preventDefault();
  checkbox.checked = !checkbox.checked;
  checkbox.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener("DOMContentLoaded", function () {
  const endlessScroll = new Ajaxinate({
    loadingText: 'Loading',
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    method: 'click',
    offset: 1000
  });
});

(function () {
  var CARD_SELECTOR = '.js-complementary-card';
  var LOG_PREFIX = '[Complementary]';
  var imageCache = {};
  var pending = {};
  var bodyObserver = null;

  function log() {
    if (typeof console === 'undefined' || !console.log) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.log.apply(console, args);
  }

  function warn() {
    if (typeof console === 'undefined' || !console.warn) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.warn.apply(console, args);
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    if (window.Shopify && Shopify.Image && typeof Shopify.Image.getSizedImageUrl === 'function') {
      return Shopify.Image.getSizedImageUrl(url, size);
    }
    return url;
  }

  function insertSecondaryImage(card, imageData) {
    if (!card) return;
    log('insertSecondaryImage', card.dataset.productHandle || 'unknown', imageData);
    if (!imageData) {
      card.dataset.secondaryState = 'none';
      return;
    }
    var mediaWrapper = card.querySelector('.media.media--hover-effect');
    if (!mediaWrapper) {
      card.dataset.secondaryState = 'none';
      return;
    }
    if (mediaWrapper.querySelectorAll('img').length > 1) {
      card.dataset.secondaryState = 'done';
      return;
    }

    var primaryImg = mediaWrapper.querySelector('img');
    var secondaryImg = primaryImg ? primaryImg.cloneNode() : document.createElement('img');
    secondaryImg.removeAttribute('srcset');
    secondaryImg.removeAttribute('sizes');
    secondaryImg.src = imageData.src;
    secondaryImg.alt = imageData.alt || '';
    secondaryImg.loading = 'lazy';
    mediaWrapper.appendChild(secondaryImg);
    card.dataset.secondaryState = 'done';
  }

  function fetchSecondaryImage(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    log('fetching secondary image for', handle);
    return fetch(root + 'products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network error');
        }
        return response.json();
      })
      .then(function (product) {
        if (!product || !product.images || product.images.length < 2) {
          return null;
        }
        return {
          src: getSizedImageUrl(product.images[1], '533x'),
          alt: product.title || ''
        };
      })
      .catch(function (error) {
        warn('fetch failed for', handle, error);
        return null;
      });
  }

  function processCard(card) {
    if (!card) return;
    var handle = card.dataset.productHandle || 'unknown';
    var currentState = card.dataset.secondaryState || 'unset';
    var mediaWrapper = card.querySelector('.media.media--hover-effect');
    var hasSecondImage = mediaWrapper ? mediaWrapper.querySelectorAll('img').length > 1 : false;

    log('processCard start', handle, 'state:', currentState, 'hasSecondImage:', hasSecondImage);

    if (currentState === 'server' && !hasSecondImage) {
      warn('state was "server" but only one image present for', handle, '- switching to client fetch');
      card.dataset.secondaryState = '';
      currentState = '';
    }

    if (hasSecondImage) {
      card.dataset.secondaryState = 'done';
      log('already has second image, skipping', handle);
      return;
    }

    if (card.dataset.secondaryState === 'done' || card.dataset.secondaryState === 'none' || card.dataset.secondaryState === 'loading') {
      log('skipping card', handle, 'state', card.dataset.secondaryState);
      return;
    }

    if (!handle || handle === 'unknown') {
      card.dataset.secondaryState = 'none';
      return;
    }

    if (Object.prototype.hasOwnProperty.call(imageCache, handle)) {
      if (imageCache[handle]) {
        insertSecondaryImage(card, imageCache[handle]);
      } else {
        card.dataset.secondaryState = 'none';
      }
      log('used cached image for', handle, imageCache[handle]);
      return;
    }

    if (!pending[handle]) {
      pending[handle] = [];
      fetchSecondaryImage(handle).then(function (imageData) {
        log('fetch complete for', handle, imageData);
        imageCache[handle] = imageData;
        var queue = pending[handle] || [];
        queue.forEach(function (queuedCard) {
          if (imageData) {
            insertSecondaryImage(queuedCard, imageData);
          } else {
            queuedCard.dataset.secondaryState = 'none';
          }
        });
        pending[handle] = null;
      });
    }

    pending[handle].push(card);
    card.dataset.secondaryState = 'loading';
  }

  function scanForCards(root) {
    if (!root) return;
    var cards = root.querySelectorAll('.js-complementary-card');
    log('scanForCards', cards.length, 'cards found');
    cards.forEach(processCard);
  }

  function observeBody() {
    if (bodyObserver) return;
    if (!document.body) return;
    bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches(CARD_SELECTOR)) {
            processCard(node);
            return;
          }
          if (node.querySelector && node.querySelector(CARD_SELECTOR)) {
            scanForCards(node);
          }
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function initComplementarySecondaryImages(contextLabel) {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', function () {
        initComplementarySecondaryImages('DOMContentLoaded-late');
      }, { once: true });
      return;
    }
    log('init invoked', contextLabel || 'direct call', 'readyState:', document.readyState);
    scanForCards(document);
    observeBody();
  }

  function handleSectionLoad(event) {
    if (event.target && event.target.querySelector && event.target.querySelector(CARD_SELECTOR)) {
      log('shopify:section:load event - rescanning');
      scanForCards(event.target);
    }
  }

  window.runComplementarySecondaryImages = function (contextLabel) {
    initComplementarySecondaryImages(contextLabel || 'manual');
  };

  document.addEventListener('shopify:section:load', handleSectionLoad);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      log('DOMContentLoaded event fired');
      initComplementarySecondaryImages('DOMContentLoaded');
    });
  } else {
    initComplementarySecondaryImages('immediate');
  }
})();

(function () {
  function isDesktopCardHover() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function bindProductCardSecondaryVideo(card) {
    if (!card || card.dataset.cardSecondaryVideoBound) return;
    var wrap = card.querySelector('.card__media-secondary-video-wrap');
    var video = wrap && wrap.querySelector('video');
    if (!video) return;
    card.dataset.cardSecondaryVideoBound = 'true';

    card.addEventListener('mouseenter', function () {
      if (!isDesktopCardHover()) return;
      var v = card.querySelector('.card__media-secondary-video-wrap video');
      if (v && v.play) v.play().catch(function () {});
    });

    card.addEventListener('mouseleave', function () {
      var v = card.querySelector('.card__media-secondary-video-wrap video');
      if (!v || !v.pause) return;
      v.pause();
      try {
        v.currentTime = 0;
      } catch (e) {}
    });
  }

  function initProductCardSecondaryVideos(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.card__media-secondary-video-wrap video').forEach(function (vid) {
      var card = vid.closest('.card-wrapper');
      bindProductCardSecondaryVideo(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initProductCardSecondaryVideos(document);
      },
      { once: true }
    );
  } else {
    initProductCardSecondaryVideos(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (
      event.target &&
      event.target.querySelector &&
      event.target.querySelector('.card__media-secondary-video-wrap video')
    ) {
      initProductCardSecondaryVideos(event.target);
    }
  });
})();

(function () {
  var WAITLIST_QUERY_PARAM = 'klaviyo_bis';
  var WAITLIST_TRIGGER_SELECTOR = '.klaviyo-bis-trigger[data-klaviyo-product-url]';
  var BIS_MODAL_ID = 'KlaviyoBisCollectionModal';

  function getMainProductRoot() {
    return document.querySelector('[id^="MainProduct-"]');
  }

  function isProductPage() {
    return Boolean(getMainProductRoot());
  }

  /* ── Klaviyo public key detection ── */
  function getKlaviyoPublicKey() {
    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (var i = 0; i < scripts.length; i++) {
      var match = scripts[i].src.match(/company_id=([^&"']+)/);
      if (match) return match[1];
    }
    return null;
  }

  /* ── Custom BIS Modal (collection / non-product pages) ── */
  function createBisModal() {
    if (document.getElementById(BIS_MODAL_ID)) return;

    var overlay = document.createElement('div');
    overlay.id = BIS_MODAL_ID;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.style.cssText =
      'display:none;position:fixed;top:0;left:0;width:100%;height:100%;' +
      'z-index:99999;background:rgba(0,0,0,.5);align-items:center;justify-content:center;';

    var inner = document.createElement('div');
    inner.style.cssText =
      'background:#F1EFE5;max-width:420px;width:90%;border-radius:8px;padding:32px;' +
      'position:relative;font-family:var(--font-heading-family,sans-serif);text-align:center;';

    inner.innerHTML =
      '<button type="button" id="' + BIS_MODAL_ID + '-close" aria-label="Close" ' +
      'style="position:absolute;top:12px;right:12px;background:none;border:none;' +
      'font-size:24px;cursor:pointer;color:#333;line-height:1;">&times;</button>' +
      '<h3 id="' + BIS_MODAL_ID + '-title" style="font-size:28px;text-transform:uppercase; font-family:grotesk-medium;' +
      'margin:0 0 8px;letter-spacing:.5px;"></h3>' +
      '<p style="font-size:13px;color:#555;margin:0 0 20px;">' +
      'Receive an email for when this item comes back in stock.</p>' +
      '<form id="' + BIS_MODAL_ID + '-form" style="display:flex;flex-direction:column;gap:12px;">' +
      '<input type="email" id="' + BIS_MODAL_ID + '-email" required ' +
      'placeholder="Enter your email" autocomplete="email" ' +
      'style="padding:12px 16px;border:1px solid #ccc;border-radius:4px;' +
      'font-size:14px;outline:none;font-family:inherit;" />' +
      '<button type="submit" id="' + BIS_MODAL_ID + '-submit" ' +
      'style="padding:12px 16px;background:#e25a2b;color:#F1EFE5;border:none;' +
      'border-radius:4px;font-size:14px;cursor:pointer;text-transform:uppercase;' +
      'font-weight:600;letter-spacing:.5px;font-family:inherit;">Notify Me</button>' +
      '</form>' +
      '<div id="' + BIS_MODAL_ID + '-success" style="display:none;padding:16px 0;">' +
      '<p style="font-size:14px;color:#333;margin:0;">' +
      "You're on the list! We'll email you when this item is back in stock.</p>" +
      '</div>' +
      '<div id="' + BIS_MODAL_ID + '-error" style="display:none;padding:8px 0;">' +
      '<p style="font-size:13px;color:#c00;margin:0;"></p>' +
      '</div>';

    overlay.appendChild(inner);
    document.body.appendChild(overlay);

    document.getElementById(BIS_MODAL_ID + '-close').addEventListener('click', closeBisModal);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeBisModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeBisModal();
    });
    document.getElementById(BIS_MODAL_ID + '-form').addEventListener('submit', handleBisFormSubmit);
  }

  function openBisModal(trigger) {
    var modal = document.getElementById(BIS_MODAL_ID);
    if (!modal) return;

    var productTitle = '';
    var card = trigger.closest('.card-wrapper');
    if (card) {
      var heading = card.querySelector('.card__heading a');
      if (heading) productTitle = heading.textContent.trim();
    }

    var variantId = trigger.getAttribute('data-klaviyo-variant-id') || '';
    document.getElementById(BIS_MODAL_ID + '-title').textContent = productTitle || 'Join Waitlist';
    document.getElementById(BIS_MODAL_ID + '-form').style.display = 'flex';
    document.getElementById(BIS_MODAL_ID + '-success').style.display = 'none';
    document.getElementById(BIS_MODAL_ID + '-error').style.display = 'none';
    document.getElementById(BIS_MODAL_ID + '-email').value = '';
    var submitBtn = document.getElementById(BIS_MODAL_ID + '-submit');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Notify Me';

    modal.setAttribute('data-variant-id', variantId);
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    setTimeout(function () {
      document.getElementById(BIS_MODAL_ID + '-email').focus();
    }, 100);
  }

  function closeBisModal() {
    var modal = document.getElementById(BIS_MODAL_ID);
    if (!modal) return;
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function showBisError(message) {
    var el = document.getElementById(BIS_MODAL_ID + '-error');
    el.style.display = 'block';
    el.querySelector('p').textContent = message;
  }

  function handleBisFormSubmit(event) {
    event.preventDefault();

    var email = document.getElementById(BIS_MODAL_ID + '-email').value.trim();
    var modal = document.getElementById(BIS_MODAL_ID);
    var variantId = modal.getAttribute('data-variant-id');
    var publicKey = getKlaviyoPublicKey();

    if (!email || !variantId) return;

    if (!publicKey) {
      showBisError('Configuration error. Please try again later.');
      return;
    }

    var submitBtn = document.getElementById(BIS_MODAL_ID + '-submit');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting\u2026';

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(publicKey),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
        body: JSON.stringify(payload)
      }
    )
      .then(function (res) {
        if (res.status === 202 || res.ok) {
          document.getElementById(BIS_MODAL_ID + '-form').style.display = 'none';
          document.getElementById(BIS_MODAL_ID + '-success').style.display = 'block';
          document.getElementById(BIS_MODAL_ID + '-error').style.display = 'none';
          return;
        }
        return res.json().then(function (body) {
          var msg = 'Something went wrong. Please try again.';
          if (body.errors && body.errors.length) msg = body.errors[0].detail || msg;
          throw new Error(msg);
        });
      })
      .catch(function (err) {
        showBisError(err.message || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify Me';
      });
  }

  /* ── Collection page: open custom modal instead of redirecting ── */
  function initCollectionWaitlistModal() {
    createBisModal();

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest(WAITLIST_TRIGGER_SELECTOR);
      if (!trigger || isProductPage()) return;

      event.preventDefault();
      event.stopPropagation();
      openBisModal(trigger);
    }, true);
  }

  /* ── Product page: keep native Klaviyo BIS auto-open ── */
  function getWaitlistLandingTrigger() {
    var productRoot = getMainProductRoot();
    if (!productRoot) return null;

    var productInfoRoot = productRoot.querySelector('.product__info-wrapper') || productRoot;
    var explicitTrigger = productInfoRoot.querySelector('.klaviyo-bis-trigger');
    if (explicitTrigger) return explicitTrigger;

    var fallbackTriggers = productInfoRoot.querySelectorAll('button, a');
    for (var index = 0; index < fallbackTriggers.length; index += 1) {
      var element = fallbackTriggers[index];
      var label = (element.textContent || '').trim().toLowerCase();
      if (!label) continue;
      if (label.indexOf('notify me') === -1 && label.indexOf('waitlist') === -1) continue;
      if (element.hasAttribute('disabled')) continue;
      return element;
    }

    return null;
  }

  function clickVisibleWaitlistTrigger(trigger) {
    if (!trigger) return false;

    var computedStyle = window.getComputedStyle(trigger);
    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') {
      return false;
    }

    if (trigger.getAttribute('aria-hidden') === 'true') {
      return false;
    }

    trigger.click();
    return true;
  }

  function shouldAutoOpenWaitlist() {
    var params = new URLSearchParams(window.location.search);
    return params.get(WAITLIST_QUERY_PARAM) === '1';
  }

  function clearWaitlistQueryParam() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has(WAITLIST_QUERY_PARAM)) return;

    url.searchParams.delete(WAITLIST_QUERY_PARAM);

    var normalizedQuery = url.searchParams.toString();
    var normalizedUrl = url.pathname;
    var nextUrl = normalizedQuery ? normalizedUrl + '?' + normalizedQuery : normalizedUrl;
    history.replaceState({}, '', nextUrl + url.hash);
  }

  function initProductPageWaitlistAutoOpen() {
    if (!isProductPage() || !shouldAutoOpenWaitlist()) return;

    var observer = null;
    var attempts = 0;
    var maxAttempts = 40;
    var interval = window.setInterval(function () {
      attempts += 1;

      if (clickVisibleWaitlistTrigger(getWaitlistLandingTrigger())) {
        window.clearInterval(interval);
        if (observer) observer.disconnect();
        clearWaitlistQueryParam();
        return;
      }

      if (attempts >= maxAttempts) {
        window.clearInterval(interval);
        if (observer) observer.disconnect();
      }
    }, 250);

    observer = new MutationObserver(function () {
      if (!clickVisibleWaitlistTrigger(getWaitlistLandingTrigger())) return;

      window.clearInterval(interval);
      observer.disconnect();
      clearWaitlistQueryParam();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden']
    });
  }

  function initWaitlistFlow() {
    initCollectionWaitlistModal();
    initProductPageWaitlistAutoOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWaitlistFlow, { once: true });
  } else {
    initWaitlistFlow();
  }
})();